function openSignUpModal() {
  if (typeof window === "undefined") return
  window.dispatchEvent(new CustomEvent("collar-open-signup-modal"))
}

module.exports = {
  openSignUpModal,
}
